import { Copy, Edit3 } from "lucide-react";
import "./AgentChatResponseToolbar.css";

import { copyMarkdownAsRichText } from "../uiHelpers";
import { AIResponseMessage } from "winslow-core";

import { FeedbackRating } from "./FeedbackRating";

type AgentChatResponseToolbarProps = {
  message: AIResponseMessage;
  children?: React.ReactNode;
  onEditInDocument?: (message: AIResponseMessage) => void;
};

export const AgentChatResponseToolbar = ({
  message,
  children,
  onEditInDocument,
}: AgentChatResponseToolbarProps) => {
  const handleCopy = async () => {
    await copyMarkdownAsRichText(message.message.kwargs.content);
  };

  const handleEditInDocument = () => {
    if (onEditInDocument) {
      onEditInDocument(message);
    }
  };

  return (
    <div className="agent-chat-response-toolbar">
      <div className="agent-chat-response-toolbar-item" onClick={handleCopy}>
        <Copy size={16} />
      </div>
      {onEditInDocument && (
        <div
          className="agent-chat-response-toolbar-item"
          onClick={handleEditInDocument}
          title="Edit in Document">
          <Edit3 size={16} />
        </div>
      )}
      {/* <div
        className="agent-chat-response-toolbar-item"
        onClick={() => toast("Thanks for the feedback!", toastSuccess)}>
        <ThumbsUp size={16} />
      </div>
      <div
        className="agent-chat-response-toolbar-item"
        onClick={() => toast("Thanks for the feedback!", toastSuccess)}>
        <ThumbsDown size={16} />
      </div> */}
      {/* <div className="agent-chat-response-toolbar-item">
        <Pencil size={16} />
      </div> */}
      {children}
      {/* Hardcoded feedback rating for now */}
      <div className="" style={{ padding: "8px" }}>
        <FeedbackRating
          feedbackRating={message.feedbackRating}
          messageId={message.id}
        />
      </div>
    </div>
  );
};
